export enum DigitalProductTabEnum {
  select = 'select',
  create = 'create',
  edit = 'edit',
}
